var _Environments = {
  development: {
    ENV: 'development',
    ENABLE_LAUNCH_DARKLY: true,
    LAUNCH_DARKLY_CLIENT_KEY: '66c5fad640f3e80ee7943e97',
    ENABLE_SENTRY: false,
    /*
    ENABLE_SENTRY: false,
    ENABLE_NEW_RELIC: false,
    ENABLE_PENDO: false,
    ENABLE_LAUNCH_DARKLY: true,
    BASE_URL: 'https://c4b8-217-180-228-201.ngrok-free.app',
    ABLY_API_KEY: 'wPFUlQ.1_a0Ng:zrRH4kVJGt0ZJQJTlR5uVdlW_2P-j-fdN1_2SX1a8gU',
    PENDO_API_KEY: 'eyJhbGciOiJSUzI1NiIsImtpZCI6IiIsInR5cCI6IkpXVCJ9.eyJkYXRhY2VudGVyIjoidXMiLCJrZXkiOiJlNTA3ZmZmM2JmMDRlMzgxNGJkNTY5Yzg3OWIxNjUyNjg5YjM4YWM2ZWE5MmY4Y2Q2ODNhODM3NGI4YmNlNDAzZWU3ZGFlMjgwMmJkZWM0YzI1MTFmNmI5YmJkNmIzMDUzNTU5NGNhMDM2MDUzZmQxYmQ3Njk1NDljMDRmMDQ4NmFlZGRmMGUzNDJjMTYxM2Y4ZTQwYmQ4Zjc3Y2NjZDBlZWZlNTY3YmEyZWMzODc3ZTJhZmMxZjRkN2ZjMmIwNjlkYWE0YWM1ZWNjY2U4MTM2ZjM1N2JiZjVjNDdiZjE5My42N2E0YzQ5OTMwM2M1NjgyMTdiODgxYzc0YjUzMWVkNi5iMTAwMmU5ODM4NTRlMjBlMGIzZDYzNWE3NGNjOWFkYmI4ZDAxYjhmZTA1Y2NkY2FhOWQ0YWU4Njc4MjNmMTdmIn0.hN7Xorp2BZ5ZwT-3nyLm3Rp7k3rhk4sxMXpDCg79nDDPO3VgafrRa4FaDnmlcvTTDYKmyIDFStzotmqCaJVnjRBIaHM4bf2Kqp_0aZKbGW3r01JtY6ELA0m4DR4JGyMcrLqZlVdsnPOZcvBJdYfdpF5DZqQOSArXNI7sthbqsb4',
    SENTRY_DSN: 'https://91696f103ecc4df2a6bc4184f3a63721@o4504467088867328.ingest.sentry.io/4505478121127936',
    NEW_RELIC_TOKEN_IOS: 'AAd40f03d9c72e1ab7d09afceb49284689127e9887-NRMA',
    NEW_RELIC_TOKEN_ANDROID: 'AA9916bf9dbe709127c2a576815bdda31f2bf70365-NRMA',
    LAUNCH_DARKLY_API_KEY: 'mob-ee4972f8-8f7d-4b88-90ce-5381b527108b',
    STREAM_CHAT_API_KEY: '6cmm9sd5d8sz',
    ENABLE_FORMS: true,
    */
  },
  test: {
    ENV: 'test',
    ENABLE_LAUNCH_DARKLY: true,
    LAUNCH_DARKLY_CLIENT_KEY: '6495170ce60fd012a08d6599',
    ENABLE_SENTRY: false,
    /*
    ENABLE_SENTRY: false,
    ENABLE_NEW_RELIC: false,
    ENABLE_PENDO: false,
    ENABLE_LAUNCH_DARKLY: true,
    BASE_URL: 'https://api.pushpulse.com',
    ABLY_API_KEY: 'wPFUlQ.1_a0Ng:zrRH4kVJGt0ZJQJTlR5uVdlW_2P-j-fdN1_2SX1a8gU',
    PENDO_API_KEY: 'eyJhbGciOiJSUzI1NiIsImtpZCI6IiIsInR5cCI6IkpXVCJ9.eyJkYXRhY2VudGVyIjoidXMiLCJrZXkiOiJlNTA3ZmZmM2JmMDRlMzgxNGJkNTY5Yzg3OWIxNjUyNjg5YjM4YWM2ZWE5MmY4Y2Q2ODNhODM3NGI4YmNlNDAzZWU3ZGFlMjgwMmJkZWM0YzI1MTFmNmI5YmJkNmIzMDUzNTU5NGNhMDM2MDUzZmQxYmQ3Njk1NDljMDRmMDQ4NmFlZGRmMGUzNDJjMTYxM2Y4ZTQwYmQ4Zjc3Y2NjZDBlZWZlNTY3YmEyZWMzODc3ZTJhZmMxZjRkN2ZjMmIwNjlkYWE0YWM1ZWNjY2U4MTM2ZjM1N2JiZjVjNDdiZjE5My42N2E0YzQ5OTMwM2M1NjgyMTdiODgxYzc0YjUzMWVkNi5iMTAwMmU5ODM4NTRlMjBlMGIzZDYzNWE3NGNjOWFkYmI4ZDAxYjhmZTA1Y2NkY2FhOWQ0YWU4Njc4MjNmMTdmIn0.hN7Xorp2BZ5ZwT-3nyLm3Rp7k3rhk4sxMXpDCg79nDDPO3VgafrRa4FaDnmlcvTTDYKmyIDFStzotmqCaJVnjRBIaHM4bf2Kqp_0aZKbGW3r01JtY6ELA0m4DR4JGyMcrLqZlVdsnPOZcvBJdYfdpF5DZqQOSArXNI7sthbqsb4',
    SENTRY_DSN: 'https://91696f103ecc4df2a6bc4184f3a63721@o4504467088867328.ingest.sentry.io/4505478121127936',
    NEW_RELIC_TOKEN_IOS: 'AAd40f03d9c72e1ab7d09afceb49284689127e9887-NRMA',
    NEW_RELIC_TOKEN_ANDROID: 'AA9916bf9dbe709127c2a576815bdda31f2bf70365-NRMA',
    LAUNCH_DARKLY_API_KEY: 'mob-d3280b9a-f1bc-491c-b4a6-5d40db385f17',
    STREAM_CHAT_API_KEY: '6b64pmgp3g86',
    ENABLE_FORMS: true,
    */
  },
  production: {
    ENV: 'production',
    ENABLE_LAUNCH_DARKLY: true,
    LAUNCH_DARKLY_CLIENT_KEY: '6495170ce60fd012a08d659a',
    ENABLE_SENTRY: true,
    /*
    ENABLE_SENTRY: true,
    ENABLE_NEW_RELIC: true,
    ENABLE_PENDO: true,
    ENABLE_LAUNCH_DARKLY: false,
    BASE_URL: 'https://api.pushpulse.com',
    ABLY_API_KEY: 'wPFUlQ.1_a0Ng:zrRH4kVJGt0ZJQJTlR5uVdlW_2P-j-fdN1_2SX1a8gU',
    PENDO_API_KEY: 'eyJhbGciOiJSUzI1NiIsImtpZCI6IiIsInR5cCI6IkpXVCJ9.eyJkYXRhY2VudGVyIjoidXMiLCJrZXkiOiJlNTA3ZmZmM2JmMDRlMzgxNGJkNTY5Yzg3OWIxNjUyNjg5YjM4YWM2ZWE5MmY4Y2Q2ODNhODM3NGI4YmNlNDAzZWU3ZGFlMjgwMmJkZWM0YzI1MTFmNmI5YmJkNmIzMDUzNTU5NGNhMDM2MDUzZmQxYmQ3Njk1NDljMDRmMDQ4NmFlZGRmMGUzNDJjMTYxM2Y4ZTQwYmQ4Zjc3Y2NjZDBlZWZlNTY3YmEyZWMzODc3ZTJhZmMxZjRkN2ZjMmIwNjlkYWE0YWM1ZWNjY2U4MTM2ZjM1N2JiZjVjNDdiZjE5My42N2E0YzQ5OTMwM2M1NjgyMTdiODgxYzc0YjUzMWVkNi5iMTAwMmU5ODM4NTRlMjBlMGIzZDYzNWE3NGNjOWFkYmI4ZDAxYjhmZTA1Y2NkY2FhOWQ0YWU4Njc4MjNmMTdmIn0.hN7Xorp2BZ5ZwT-3nyLm3Rp7k3rhk4sxMXpDCg79nDDPO3VgafrRa4FaDnmlcvTTDYKmyIDFStzotmqCaJVnjRBIaHM4bf2Kqp_0aZKbGW3r01JtY6ELA0m4DR4JGyMcrLqZlVdsnPOZcvBJdYfdpF5DZqQOSArXNI7sthbqsb4',
    SENTRY_DSN: 'https://91696f103ecc4df2a6bc4184f3a63721@o4504467088867328.ingest.sentry.io/4505478121127936',
    NEW_RELIC_TOKEN_IOS: 'AAd40f03d9c72e1ab7d09afceb49284689127e9887-NRMA',
    NEW_RELIC_TOKEN_ANDROID: 'AA9916bf9dbe709127c2a576815bdda31f2bf70365-NRMA',
    LAUNCH_DARKLY_API_KEY: 'mob-a3231350-b9b6-48f3-9258-2a8d9ec00fe8',
    STREAM_CHAT_API_KEY: '6b64pmgp3g86',
    ENABLE_FORMS: false,
    */
  },
}

function getEnvironment() {
  var platform = process.env.NODE_ENV; // development, test or production

  return _Environments[platform]
}

export const Environment = getEnvironment()